type RoundEditIconProps = React.SVGProps<SVGSVGElement> & {
  currentColor?: string;
};

export default function RoundEditIcon({
  className,
  currentColor,
  ...props
}: RoundEditIconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2209_35109)">
        <path
          d="M18.3334 9.99984V14.9998C18.3334 16.8408 16.841 18.3332 15.0001 18.3332H5.00008C3.15913 18.3332 1.66675 16.8408 1.66675 14.9998V4.99984C1.66675 3.15889 3.15913 1.6665 5.00008 1.6665H10.0001M13.072 3.35213C13.072 3.35213 13.072 4.54404 14.264 5.73596C15.4559 6.92787 16.6478 6.92787 16.6478 6.92787M7.62898 13.3245L10.132 12.9669C10.493 12.9153 10.8276 12.748 11.0855 12.4901L17.8397 5.73595C18.498 5.07768 18.498 4.0104 17.8397 3.35213L16.6478 2.16021C15.9895 1.50193 14.9222 1.50193 14.264 2.16021L7.50978 8.91439C7.25189 9.17229 7.0846 9.50687 7.03302 9.86792L6.67544 12.3709C6.59598 12.9272 7.07275 13.4039 7.62898 13.3245Z"
          stroke={currentColor}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2209_35109">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
